import React, { useState , useEffect} from 'react';
import styles from './review.module.scss';
import { Container, Row, Col } from 'react-bootstrap';
import { CustomButton } from '../../../../../shared/customButton';
import { editCVFilterStep, editExternalAssessmentStep, editPipelineStepInterview, editQuizStep, editReferenceCheckStep, editCustomEvaluationStep, editOneWayInterviewStep } from '../../../../../../services/util/hiringpipeline/steps';
import { editPipelineStepCVReview } from '../../../../../../services/util/hiringpipeline/steps';
import StarRating from '../../../../../shared/rate';

const Review = (props) => {

    const [state, setState] = useState(false);

    const submitDetails = async () => {
        setState(true)
        if (props.values.step_type_code === "CvReviewStep") {
            let userIDArray = [];
            props.values.type_specific_parameters.reviewers.forEach(element => {
                userIDArray.push(element.value)
            });

            let respond = await editPipelineStepCVReview(props.values.pipeline_step_id, props.values.type_specific_parameters.evaluation_criteria, userIDArray, props.values.type_specific_parameters.number_of_reviewers_per_cv, props.values.type_specific_parameters.minimum_pass_score,props.values.type_specific_parameters.review_criteria)
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();

            } else {
                setState(false)
            }
        } else if (props.values.step_type_code === "InterviewStep") {
            let respond = await editPipelineStepInterview(props.values.pipeline_step_id, props.values.type_specific_parameters.evaluation_criteria, props.values.type_specific_parameters.minimum_pass_score, props.values.type_specific_parameters.interview_guidelines_to_candidate,props.values.type_specific_parameters.review_criteria);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();
            }
            else {
                setState(false)
            }
        } else if (props.values.step_type_code === "ExternalAssessmentStep") {

            let userIDArray = [];
            userIDArray.push(props.values.type_specific_parameters.assessment_reviewers.value)

            let respond = await editExternalAssessmentStep(props.values.pipeline_step_id, props.values.type_specific_parameters.evaluation_criteria, userIDArray, props.values.type_specific_parameters.minimum_pass_score, props.values.assessment, props.values.type_specific_parameters.assessment_expire_in,props.values.type_specific_parameters.review_criteria);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();
            }
            else {
                setState(false)
            }
        } else if (props.values.step_type_code === "AutomatedCVFilterStep") {

            let respond = await editCVFilterStep(props.values.pipeline_step_id, props.values.keywordCount, props.values.keywords);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();
            }
            else {
                setState(false)
            }
        } else if (props.values.step_type_code === "QuizStep") {

            let respond = await editQuizStep(props.values.pipeline_step_id, props.values.type_specific_parameters.minimum_pass_score, props.values.type_specific_parameters.quiz_template.value, props.values.type_specific_parameters.quiz_expire_in);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();
            }
            else {
                setState(false)
            }
        } else if (props.values.step_type_code === "ReferenceCheckStep") {

            let userIDArray = [];
            userIDArray.push(props.values.type_specific_parameters.reference_check_reviewers.value)

            let respond = await editReferenceCheckStep(props.values.pipeline_step_id, props.values.type_specific_parameters.evaluation_criteria, props.values.type_specific_parameters.min_no_of_references_required, props.values.type_specific_parameters.guide_for_candidates, props.values.type_specific_parameters.is_auto_request_referee_details_from_candidate_enabled, userIDArray);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();
            }
            else {
                setState(false)
            }
        } else if (props.values.step_type_code === "CustomEvaluationStep") {

            let userIDArray = [];
            userIDArray.push(props.values.type_specific_parameters.custom_evaluation_reviewers.value)

            let respond = await editCustomEvaluationStep(props.values.pipeline_step_id, props.values.type_specific_parameters.evaluation_criteria, props.values.type_specific_parameters.minimum_pass_score, userIDArray, props.values.type_specific_parameters.custom_evaluation_description,props.values.type_specific_parameters.review_criteria);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();
            }
            else {
                setState(false)
            }
        } else if (props.values.step_type_code === "OneWayInterviewStep") {

            let userIDArray = [];
            userIDArray.push(props.values.type_specific_parameters.one_way_interview_reviewers.value)

            let respond = await editOneWayInterviewStep(props.values.pipeline_step_id, props.values.type_specific_parameters.evaluation_criteria, props.values.type_specific_parameters.minimum_pass_score, userIDArray, props.values.type_specific_parameters.expire_in, props.values.type_specific_parameters.one_way_interview_template.value,props.values.type_specific_parameters.review_criteria);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();
            }
            else {
                setState(false)
            }
        } else {
            setState(false)
        }
    }

    return (
        <div>

            <Container>

                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Stage&nbsp;Name&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_editStagesModal_review_stageNameReviewModeId">{props.values.step_name}</span>
                    </Col>
                </Row>

                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Stage&nbsp;Type&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_editStagesModal_review_stageTypeReviewModeId">{props.values.step_type}</span>
                    </Col>
                </Row>

                {
                    (props.values.step_type_code === "CvReviewStep") &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                                <span className={styles.rowValues}>
                                    {props.values.type_specific_parameters.reviewers.map((value, index) => (
                                        <p className="mb-1" key={index}><i className="fas fa-circle"></i>&nbsp;{value.label}</p>
                                    ))
                                    }
                                </span>
                            </Col>
                        </Row>
                    </div>
                }
                {
                    (props.values.step_type_code === "ExternalAssessmentStep") &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                                <span className={styles.rowValues}>
                                    <p className="mb-1" ><i className="fas fa-circle"></i>&nbsp;{props.values.type_specific_parameters.assessment_reviewers.label}</p>
                                </span>
                            </Col>
                        </Row>
                    </div>
                }
                {
                    (props.values.step_type_code === "ReferenceCheckStep") &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                                <span className={styles.rowValues}>
                                    <p className="mb-1" ><i className="fas fa-circle"></i>&nbsp;{props.values.type_specific_parameters.reference_check_reviewers.label}</p>
                                </span>
                            </Col>
                        </Row>
                    </div>
                }
                {
                    (props.values.step_type_code === "CustomEvaluationStep") &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                                <span className={styles.rowValues}>
                                    <p className="mb-1" ><i className="fas fa-circle"></i>&nbsp;{props.values.type_specific_parameters.custom_evaluation_reviewers.label}</p>
                                </span>
                            </Col>
                        </Row>
                    </div>
                }
                {
                    (props.values.step_type_code === "OneWayInterviewStep") &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Interview&nbsp;Template&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.type_specific_parameters.one_way_interview_template.label}</span>
                        </Col>
                    </Row>
                }
                {
                    (props.values.step_type_code === "OneWayInterviewStep") &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                                <span className={styles.rowValues}>
                                    <p className="mb-1" ><i className="fas fa-circle"></i>&nbsp;{props.values.type_specific_parameters.one_way_interview_reviewers.label}</p>
                                </span>
                            </Col>
                        </Row>
                    </div>
                }
                {props.values.step_type_code === "CvReviewStep" &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>No&nbsp;Of&nbsp;Reviewers&nbsp;Per&nbsp;CV&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_editStagesModal_review_noOfReviewersPerCvId">{props.values.type_specific_parameters.number_of_reviewers_per_cv}</span>
                        </Col>
                    </Row>
                }

                {props.values.step_type_code === "InterviewStep" &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Interview&nbsp;Guidelines&nbsp;For&nbsp;Candidates&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_editStagesModal_review_interviewGuidelinesForCandidatesId">{props.values.type_specific_parameters.interview_guidelines_to_candidate}</span>
                            </Col>
                        </Row>
                    </div>
                }
                {
                    (props.values.step_type_code === "QuizStep") &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Quiz&nbsp;Template&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.type_specific_parameters.quiz_template.label}</span>
                        </Col>
                    </Row>
                }
                {(props.values.step_type_code === "ReferenceCheckStep" ) &&
                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>No&nbsp;Of&nbsp;Reference&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.type_specific_parameters.min_no_of_references_required}</span>
                        </Col>
                    </Row>
                }
                 {(props.values.step_type_code === "ReferenceCheckStep" ) &&
                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Request referee details automatically :</span>&nbsp;<span className={styles.rowValues}>{props.values.type_specific_parameters.is_auto_request_referee_details_from_candidate_enabled? 'Active': 'Inactive'}</span>
                        </Col>
                    </Row>
                }

                {(props.values.step_type_code === "CvReviewStep" || props.values.step_type_code === "InterviewStep" || props.values.step_type_code === "ExternalAssessmentStep" || props.values.step_type_code === "QuizStep" || props.values.step_type_code === "ReferenceCheckStep" || props.values.step_type_code === "CustomEvaluationStep" || props.values.step_type_code === "OneWayInterviewStep") &&
                    <div>
                        {(props.values.step_type_code != "ReferenceCheckStep") &&
                            <Row className={styles.pipelineDetailsRow}>
                                <Col xs={12} className="mt-1 mb-1">
                                    <span className={styles.rowSubTitle}>Minimum&nbsp;Pass&nbsp;Score&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_editStagesModal_review_minimumPassScoreId">{props.values.type_specific_parameters.minimum_pass_score}</span>
                                </Col>
                            </Row>
                        }
                        {(props.values.step_type_code != "QuizStep" || props.values.step_type_code === "ReferenceCheckStep") &&
                            <Row className={styles.pipelineDetailsRow}>
                                <Col xs={12} className="mt-1 mb-1">
                                    <span className={styles.rowSubTitle}>Guideline&nbsp;For&nbsp;Reviewers&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_editStagesModal_review_guidelineForReviewersId">{props.values.type_specific_parameters.evaluation_criteria}</span>
                                </Col>
                            </Row>
                        }
                    </div>
                }
                 {props.values.step_type_code === "ReferenceCheckStep" &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Guidelines&nbsp;For&nbsp;Candidates&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.type_specific_parameters.guide_for_candidates}</span>
                            </Col>
                        </Row>
                    </div>
                }

                {props.values.step_type_code === "CustomEvaluationStep" &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Evaluation Description&nbsp;For&nbsp;Reviewers&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_editStagesModal_review_evaluationDescriptionForReviewresId">{props.values.type_specific_parameters.custom_evaluation_description}</span>
                            </Col>
                        </Row>
                    </div>
                }

                {props.values.step_type_code === "AutomatedCVFilterStep" &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Keywords to Scan&nbsp;:</span><br />
                                <span className={styles.rowValues}>
                                    {props.values.keywords.map((value, index) => (
                                        <p className="mb-1" key={index} id={`adminPanel_hiringPipeline_editPipeline_editStagesModal_review_ddedKeywordId.${index}`}><i className="fas fa-circle"></i>&nbsp;{value}</p>
                                    ))
                                    }
                                </span>
                            </Col>
                        </Row>

                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Minimum&nbsp;Keyword&nbsp;Count&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_editStagesModal_review_minimumRequiredKeywordCountId">{props.values.keywordCount}</span>
                            </Col>
                        </Row>
                    </div>
                }
                {props.values.step_type_code === "ExternalAssessmentStep" &&
                    <div>
                        <div>
                            <Row className={styles.assignmentPipelineDetailsRow}>
                                <Col xs={12} className="mt-1 mb-1">
                                    <span className={styles.rowSubTitle}>Assignment&nbsp;:</span>&nbsp;<span className={styles.rowValues}><div className="ql-editor" dangerouslySetInnerHTML={{ __html: props.values.assessment }} id="adminPanel_hiringPipeline_editPipeline_editStagesModal_review_assessmentReveiewModeId"></div></span>
                                </Col>
                            </Row>
                            <Row className={styles.pipelineDetailsRow}>
                                <Col xs={12} className="mt-1 mb-1">
                                    <span className={styles.rowSubTitle}>Assignment Expire After&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_editStagesModal_review_assessmentExpireAfter">{props.values.type_specific_parameters.assessment_expire_in}</span>
                                </Col>
                            </Row>
                        </div>
                    </div>
                }
                {(props.values.step_type_code === "QuizStep") &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Quiz Expire After&nbsp;:</span>&nbsp;<span className={styles.rowValues} id="adminPanel_hiringPipeline_editPipeline_editStagesModal_review_quizExpireAfterId">{props.values.type_specific_parameters.quiz_expire_in}</span>
                            </Col>
                        </Row>
                    </div>
                }
                {(props.values.step_type_code === "OneWayInterviewStep") &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Interview Expire After&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.type_specific_parameters.expire_in}</span>
                            </Col>
                        </Row>
                    </div>
                }
                {(props.values.step_type_code === "OneWayInterviewStep" || props.values.step_type_code === "ExternalAssessmentStep" ||props.values.step_type_code === "CustomEvaluationStep" || props.values.step_type_code === "CvReviewStep" || props.values.step_type_code === "InterviewStep")  &&
                <div>
                     <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className={styles.colWithNoSidePadding}>
                                <span className={styles.rowSubTitle}>Evaluation&nbsp;criteria&nbsp;for&nbsp;candidates&nbsp;</span>&nbsp;<br />
                                <div className='mt-2 mb-2'>
                                {((props.values.type_specific_parameters.review_criteria) && (props.values.type_specific_parameters.review_criteria).length > 0) ?
                                    (props.values.type_specific_parameters.review_criteria).map((values, index) => (
                                        <span className={styles.cardValues} key={index}><div className={styles.cardValuesBox}>
                                            <div className={styles.svgDiv}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <rect width="24" height="24" rx="16" fill="#D1F3FA" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0964 7.39004L9.93638 14.3L8.03638 12.27C7.68638 11.94 7.13638 11.92 6.73638 12.2C6.34638 12.49 6.23638 13 6.47638 13.41L8.72638 17.07C8.94638 17.41 9.32638 17.62 9.75638 17.62C10.1664 17.62 10.5564 17.41 10.7764 17.07C11.1364 16.6 18.0064 8.41004 18.0064 8.41004C18.9064 7.49004 17.8164 6.68004 17.0964 7.38004V7.39004Z" fill="#32B5D3" />
                                                </svg>
                                            </div>
                                            <div className={styles.starRatingMainDiv}>
                                                <span className={styles.labelSpan} id={`adminPanel_hiringPipelines_createPipelineModal_review_reviewCriteriaReviewId.${index}`}>{values.label}</span>
                                                <span className='mt-n1'><StarRating disabled={true} id={index} /></span> 
                                            </div>

                                        </div></span>
                                    ))
                                    :
                                    <span className={styles.rowValues}>No data available</span>
                                }
                                </div>
                            </Col>
                        </Row>
                </div>

                }


                <Row className={styles.actionBtns}>
                    <Col className="ps-0">
                        {<CustomButton
                            id="edit_evaluation_go_back_btn"
                            buttonType="submit"
                            label="Back"
                            type="defaultBtn"
                            handleClick={() => props.previousPage(1)}

                        />}
                    </Col>
                    <Col className="pe-0">
                        {<CustomButton
                            id="adminPanel_hiringPipeline_editPipeline_editStagesModal_review_reviewSaveBtnId"
                            buttonType="submit"
                            label="Save"
                            type="primaryBtn"
                            disabled={state === true ? true : false}
                            backicon={
                                state === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                    : ''
                            }
                            handleClick={() => submitDetails()}
                        />}
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Review;